// Deep imports rather than the `@/features/hazards` barrel. The barrel exports `./data` before
// `./domain`, so a mapper reaching back through it for an enum is evaluated while `./domain` is
// still initialising and sees `undefined` — which makes this module, and anything importing it,
// impossible to load in isolation (KUDO1-9541).
import { HAZARD_MARKERS } from '@/features/hazards/utils/constants';
import { CentreSubType } from '@/features/hazards/domain/entities/types/entity-sub-type/centres';
import type { Scheme } from '@/features/hazards/domain/entities/types/scheme';

type CentresToSchemeMap = Record<CentreSubType, Scheme>;

export const centresToSchemeMap: CentresToSchemeMap = {
  [CentreSubType.EvacuationCentreEntity]: {
    icon: HAZARD_MARKERS['ew-evacuation-centre'],
  },
  [CentreSubType.EvacuationRespiteCentreEntity]: {
    icon: HAZARD_MARKERS['ew-evacuation-centre'],
  },
};
